export default class Result {
    public creditsWon: number = 0;
    public freespinsWon: number = 0;

}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./~/slotworks/model/gameplay/records/results/result.ts